import { render, staticRenderFns } from "./UpdateAccountForm.vue?vue&type=template&id=771f754a&scoped=true"
import script from "./UpdateAccountForm.vue?vue&type=script&lang=ts"
export * from "./UpdateAccountForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771f754a",
  null
  
)

export default component.exports